import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import { Box, IconButton } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router';
import Images from '../../Assets/assetHelper';
import routes from '../../Utils/routes';
import { ReactChildren } from '../../interfaces/Common';
import { useStyles } from '../AppLayout/styles';
import AppBreadCrumbs from '../BreadCrumbs';
import GoBackIcon from '../GoBackIcon';

interface INestedPageLayoutProps extends ReactChildren {
  hideBreadcrumbs?: boolean;
}

const NestedPageLayout: React.FunctionComponent<INestedPageLayoutProps> = ({ children, hideBreadcrumbs }) => {
  const navigate = useHistory();
  const classes = useStyles();
  return (
    <Box sx={{ height: '100vh', overflow: 'hidden', background: '#FFF' }}>
      <Box className="mobile-safe-header" sx={{ borderBottom: '1px solid #F0EDF6', minHeight: '8%' }}>
        <Box className={classes.header} style={{ boxShadow: 'none' }}>
          {/* .mobile-safe-header (outer) only adds env(safe-area-inset-top), which is 0
              in a regular browser (no notch to avoid) - that left the back arrow/
              breadcrumb/notification/chat row flush against the very top edge with no
              baseline spacing. This adds a fixed minimum that stacks on top of whatever
              safe-area padding is actually present on a real device. */}
          <Box className={classes.mobileHeaderContainer} sx={{ alignItems: 'center', pt: '14px', pb: '10px' }}>
            <GoBackIcon needBGgColor={false} />
            <Box>
              <AppBreadCrumbs hideTrail={hideBreadcrumbs} />
            </Box>
            <Box sx={{ gap: '10px' }}>
              <IconButton onClick={() => navigate.push(routes.notifcation)}>
                <img src={Images.Icons.notificationIcon} alt="" />
              </IconButton>
              <IconButton sx={{ background: '#F0EDF6' }} onClick={() => navigate.push(routes.chat)}>
                <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: '16px', color: '#604797' }} />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ background: '#FFF', height: '92%', overflow: 'auto' }}>
        <Box sx={{ m: '10px 16px ' }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default NestedPageLayout;
